import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

function PaymentFailed() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const orderId = searchParams.get('orderId');

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', bgcolor: '#f5f5f5' }}>
            <Paper sx={{ p: 5, textAlign: 'center', maxWidth: 450, borderRadius: 3 }}>
                <ErrorOutlineIcon sx={{ fontSize: 80, color: 'error.main', mb: 2 }} />
                <Typography variant="h4" gutterBottom fontWeight="bold">
                    Paiement échoué
                </Typography>
                <Typography variant="body1" color="text.secondary" gutterBottom>
                    Votre paiement n'a pas pu être traité. Aucun montant n'a été débité.
                </Typography>
                {orderId && (
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Réf : {orderId}
                    </Typography>
                )}
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 3 }}>
                    <Button
                        variant="outlined"
                        size="large"
                        onClick={() => navigate('/dashboard')}
                    >
                        Retour au tableau de bord
                    </Button>
                    <Button
                        variant="contained"
                        size="large"
                        onClick={() => navigate('/dashboard')}
                    >
                        Réessayer
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
}

export default PaymentFailed;
